/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import { LinkToAnotherAuth, submitSignUp } from '../components/authentication';
import {
  NewPasswordInputs,
  usePasswordInputs,
  EmailInput,
} from '../components/authentication/AuthComponent';
import Form from '../components/Form';
import { SignInSignUpContainer } from '../components/PaperOnCenter';

export default function SignUp() {
  const passwordInputs = usePasswordInputs();

  return (
    <SignInSignUpContainer
      title="Sign Up"
      Form={
        <Form
          mutation={submitSignUp}
          validate={passwordInputs.validate}
          Inputs={
            <>
              <EmailInput />
              <NewPasswordInputs {...passwordInputs} />
            </>
          }
          SubmitButtonTitle="Sign up"
          SecondaryAction={
            <LinkToAnotherAuth authLink="/signin">
              Already have an account? Sign in
            </LinkToAnotherAuth>
          }
        />
      }
    />
  );
}
